



import {Component, Prop, Vue} from 'vue-property-decorator';
import TutorialStep from "@/components/Teamplates/Tutorial/Tutorial.vue";
import ButtonOutlineSuccessful from "@/components/Atoms/ButtonOutlineSuccessful/ButtonOutlineSuccessful.vue";
import FooterButton from "@/components/Atoms/FooterButton/FooterButton.vue";
import Categories from "@/constants/category";
import {ServiceFactory} from "@/services";
import {TutorialDto, TutorialModel} from "@/share";
import {CHECKBOX_STATUS, BABY} from "@/constants";

const BabyService = ServiceFactory.get('baby');

@Component({
  components: {
    TutorialStep,
    ButtonOutlineSuccessful,
    FooterButton,
  }
})
export default class TutorialPage extends Vue {

  private tutorialStep = 1
  private category = Categories[this.tutorialStep - 1];
  private tutorials: TutorialModel[] = []
  private babyId = this.$route.params.id
  private milestoneIds: number[] = []
  private isLoadingPrevButton = false
  private isLoadingNextButton = false

  created() {
    this.getTutorials()
  }

  private get prevButtonClass():string {
    return this.isLoadingPrevButton ? 'overlay' : ''
  }

  private get nextButtonClass():string {
    return this.isLoadingNextButton ? 'overlay' : ''
  }

  private get nextVariant():string {
    return this.isLoadingNextButton ? 'warning-outline' : ''
  }

  private async getTutorials(): Promise<void> {
    this.tutorials = await BabyService.getTutorials(this.babyId).catch(() => [])
  }

  private onChangeCheckbox(status: number, value: number) {
    if (status == CHECKBOX_STATUS.ACCEPTED) {
      this.milestoneIds.push(value);
      return
    }

    const index = this.milestoneIds.indexOf(value);
    if (index > -1) {
      this.milestoneIds.splice(index, 1);
    }
  }

  private async setTutorials(): Promise<any> {
    const payload: TutorialDto = new TutorialDto({
      ids: this.milestoneIds.join(',')
    })
    const response = await BabyService.setTutorials(this.babyId, payload).catch(() => [])

    if (response.hasError) return // TODO handler error
    localStorage.setItem(BABY.SELECTED, this.$route.params.id);
    return this.$router.push({name: 'routes.tutorial.finish'})
  }

  private onClickToButtonNextQuestion(): any {
    this.isLoadingNextButton = true
    setTimeout(() => {
      this.isLoadingNextButton = false
      if (this.isFinish) return this.setTutorials()

      this.tutorialStep++
      this.category = Categories[this.tutorialStep - 1]
    }, 100)
  }

  private onClickToButtonBeforeQuestion(): void {
    this.isLoadingPrevButton = true
    setTimeout(() => {
      this.isLoadingPrevButton = false
      if (this.tutorialStep > 1) {
        this.tutorialStep--
        this.category = Categories[this.tutorialStep - 1]
      }
    }, 100)
  }

  private get isFinish(): boolean {
    return this.tutorialStep == 7
  }
}
